import Util from '@/lib/util'
export default [
    {
        title:Util.L('Warehouse'),
        key:'tenantName'
    },
    {
        title:Util.L('Client'),
        key:'clientName'
    }]